﻿import React, { useState, useEffect } from 'react';
import { CrudFunctions } from '../utilities/crud-functions';
import { AttachedImage } from '../models/attached-image';
import { ImageType, MessageBoxReplyType } from '../models/enums';
import { LookupItem } from '../models/lookup-item';
import { ItemBasicInformation } from '../models/item-basic-information';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';
import { BenchSheetTechnologyType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import {
    TextBox,
    SelectBox,
    CheckBox
} from 'devextreme-react';

import { RadioGroup } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { MessageBoxReply } from '../models/message-box-reply';

const DELETE_IMAGE_WARNING = 10;

let key = 0;

export enum captureOptionTypes {
    BrowseFile = 1,
    DragNDrop = 2
}

const captureOptions = [
    { id: captureOptionTypes.BrowseFile, name: 'Browse file' },
    { id: captureOptionTypes.DragNDrop, name: 'Drag and drop' }
];

export interface Props {
    parentId: string;
    technology?: BenchSheetTechnologyType;
    imageType?: ImageType;
    title?: string;
    readOnly?: boolean;
    canDelete?: boolean;
}

export default function ImageHandler(props: Props) {

    const [images, setImages] =
        useState<AttachedImage[]>();

    const [currentImage, setCurrentImage] =
        useState<AttachedImage | any>();

    const [imageTypes, setImageTypes] =
        useState<LookupItem[]>();

    const [selectedCofAImageType, setSelectedCofAImageType] =
        useState<number>();

    const [captureTypeId, setCaptureTypeId] =
        useState<number>(3);

    const [imagePreviewVisible, setImagePreviewVisible] =
        useState<boolean>(true);

    const [showImagePreviewActualSize, setShowImagePreviewActualSize] =
        useState<boolean>(false);

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>(false);

    const [itemBasicInitInformation, setItemBasicInitInformation] =
        useState<ItemBasicInformation>();

    const [imageReady, setImageReady] =
        useState<boolean>(false);

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        setImageReady(true);
    }, [currentImage]);

    ++key;

    let fileLoadrCss = captureTypeId === 1 ? "visibleComponent" : "collapsedComponent";
    let dragndropCss = captureTypeId === 2 ? "visibleComponent" : "collapsedComponent";

    let imageCss = showImagePreviewActualSize ? '' : 'image-preview-actual-size';

    return (
        <div>
            <div className="lq-sub-title pw-margin-top-05 pw-margin-bottom-05">{props.title}</div>
            <div>
                <div className="image-capture-controls">
                    <div>
                        <RadioGroup readOnly={props.readOnly}
                            items={captureOptions}
                            valueExpr="id"
                            displayExpr="name"
                            onValueChanged={changeCaptureType}
                            value={captureTypeId}
                            layout="horizontal" />
                    </div>

                    {!props.imageType &&
                    <div>
                        <div className="form-unit pw-section-right-margin-1">
                            <label className="textbox-label">Image Type</label>
                            <SelectBox readOnly={props.readOnly}
                                id="imageType"
                                className="asset-selectbox"
                                valueExpr="id"
                                displayExpr="description"
                                disabled={imageTypes && imageTypes.length < 2}
                                value={selectedCofAImageType ? selectedCofAImageType : undefined}
                                dataSource={imageTypes}
                                onValueChanged={changeImageType} />

                        </div>
                    </div>
                    }
                </div>

                <div className="pw-form-unit-label pw-margin-bottom-1">Please select an image type</div>
                
                {(!props.readOnly && selectedCofAImageType && captureTypeId === captureOptionTypes.BrowseFile) &&
                    <div className="pw-margin-bottom-1">
                        <div className={fileLoadrCss}>
                            <div className="ic-player-frame">
                                <input type="file" accept="image/*" id="file-input" onChange={onFileLoaderChange}></input>
                            </div>
                        </div>
                    </div>
                }
                
                {(!props.readOnly && selectedCofAImageType && captureTypeId === captureOptionTypes.DragNDrop) &&
                    <div className={dragndropCss}>
                        <div className="ic-player-frame">
                            <div id="ImageDnDTarget" className="ic-dnd-target"
                                onDrop={onFileDrop}
                                onDragOver={onFileDragOver}>
                                <div className="ic-dnd-target-text">You can drag an image file here</div>
                            </div>
                        </div>
                    </div>
                }
            </div>

            <div className="imageCaptureThumbnailList">
                {images && images.length > 0 && images.map((image) =>
                    <div className="imageCaptureThumb"
                        key={image && image.imageId && image.imageId.toString()}>
                        <div id={image && image.imageId}
                            onClick={selectedImageChanged}
                            className="documentThumb" >
                            <img alt="thumb"
                                className="imageThumb"
                                src={`data:image/png;base64, ${image.base64Blob}`} />
                            <div id="imageThumbText" className="documentThumbText">{image.name}</div>
                        </div>
                    </div>
                )}
            </div>

            {/*
                     <div className="imageCaptureThumbnailList">
                    {this.props.images && this.props.images.length > 0 && this.props.images.map((image) =>
                        <div className="imageCaptureThumb"
                            key={image && image.imageId && image.imageId.toString()}>
                            <img id={image && image.imageId && image.imageId}
                                onClick={this.selectedImageChanged} alt="thumb"
                                className="imageThumb" src={`data:image/png;base64, ${image.base64Blob}`} />
                        </div>
                    )}
                </div>
                */}

            {imagePreviewVisible && imageReady && currentImage &&

                <DialogPopup
                    visible={imagePreviewVisible}
                    onHiding={hideImagePreview}
                    dragEnabled={true}
                    resizeEnabled={true}
                    hideOnOutsideClick={false}
                    height={'80%'}
                    width={'80%'}
                    showTitle={true}
                    title="Image Preview">
                    <div className="image-preview-container">
                        <div className="blob-preview-toolbar">
                            <CheckBox text="Show actual image size"
                                onValueChanged={showImagePreviewActualSizeChanged}
                                value={showImagePreviewActualSize} />

                            <div className="title-bar-spacer" />
                            <div >
                                <div>
                                    <Button className="title-bar-button"
                                        text="" icon="info" type="success"
                                        hint="item information"
                                        onClick={onImageInfoButtonClick} />
                                </div>
                            </div>
                        </div>

                        <div className="image-preview-img-container">
                            <img className={imageCss} alt="preview" src={currentImage ?
                                `data:${currentImage.mimeTypeString};base64,${currentImage.base64Blob}` : ''} />
                        </div>

                        <div className="image-preview-textboxes">
                            <div className="form-unit">
                                <label className="textbox-label">Name</label>
                                <TextBox id="currentImageName" readOnly={props.readOnly}
                                    className="textbox"
                                    placeholder="NA"
                                    value={currentImage && currentImage.name ? currentImage.name : undefined}
                                    onValueChanged={onImageNameValueChanged} />

                                {/*
                            <TextBox id="currentImageName" readOnly={props.readOnly}
                                className="textbox"
                                placeholder="NA"
                                value={imageName ? imageName : currentImage ? currentImage.name : undefined}
                                onValueChanged={e => { this.setState({ imageName: e.value }); }} />
                                */}


                            </div>
                            <div className="form-unit">
                                <label className="textbox-label">Description</label>
                                <TextBox id="currentImageDescription" className="textbox"
                                    placeholder="NA" readOnly={props.readOnly}
                                    value={currentImage && currentImage.description ? currentImage.description : undefined}
                                    onValueChanged={onImageDescriptionValueChanged} />

                                {/*
                            <TextBox id="currentImageDescription" className="textbox"
                                placeholder="NA" readOnly={props.readOnly}
                                value={imageDescription ? imageDescription : currentImage ? currentImage.description : undefined}
                                onValueChanged={e => { this.setState({ imageDescription: e.value }); }} />
                                */}
                            </div>
                        </div>
                        <div>
                            <div className="pw-form-unit-label">Image Type</div>
                            <div className="pw-readonly-label">{currentImage && currentImage.imageType ? ImageType[currentImage.imageType] : 'NA'}</div>
                        </div>

                        <div className="image-preview-buttons">
                            {currentImage &&
                                <Button id="saveImage" text="Save" icon="save" type="normal"
                                    className="image-preview-button" disabled={props.readOnly}
                                    onClick={onImagePreviewSave} />
                            }
                            {currentImage && currentImage.imageId &&
                                <Button id="downloadDocument" text="Download" icon="save" type="normal"
                                    className="image-preview-button"
                                    onClick={onImageDownload} />
                            }
                            {currentImage && currentImage.imageId &&
                                <Button id="deleteDocument" text="Delete" icon="trash" type="normal"
                                    className="image-preview-button"
                                    onClick={onImageDeleteClick} />
                            }
                            <Button id="cancelImage" text="Cancel" icon="arrowleft" type="normal"
                                className="image-preview-button"
                                onClick={onImagePreviewCancel} />

                        </div>

                        {itemBasicInformationDialogVisible &&
                            <DialogPopup visible={itemBasicInformationDialogVisible}
                                onHiding={hideItemBasicInformationDialog}
                                hideOnOutsideClick={false}
                                title="Item Basic Information"
                                width={'25rem'}
                                height={'21rem'}
                                dragEnabled={false}
                                resizeEnabled={false}>
                                <ItemBasicInformationDialog initInformation={itemBasicInitInformation}
                                    onOkClick={hideItemBasicInformationDialog} />
                            </DialogPopup>
                        }
                    </div>
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata}
                    onReply={onGlobalDialogReply} onClose={clearGlobalDialog} />
            }
        </div>
    );



    function showImagePreview() {
        setImagePreviewVisible(true);
    }

    function hideImagePreview() {
        setImagePreviewVisible(false);
    }

    function showImagePreviewActualSizeChanged(e: any) {
        setShowImagePreviewActualSize(e.value);
    }

    function onImageNameValueChanged(e: any) {
        setCurrentImage({ ...currentImage, name: e.value });
    }

    function onImageDescriptionValueChanged(e: any) {
        setCurrentImage({ ...currentImage, description: e.value });
    }

    async function onImagePreviewSave() {
        if (currentImage && selectedCofAImageType) {

            let image = { ...currentImage };
            image.parentId = props.parentId;
            //needed?
            image.imageType = selectedCofAImageType;

            /*
            currentImage.imageType = selectedCofAImageType;

            let image: AttachedImage = {
                name:  currentImage.name,
                description: currentImage.description,
                imageType: currentImage.imageType,
                base64Blob: currentImage.base64Blob,
                mimeTypeString: currentImage.mimeTypeString,
                parentId: props.parentId, // currentImage.parentId
                imageId: currentImage.imageId
            };
            */

            await insertImage(image)
                .then(() => {
                    getImages();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Inserting Image");
                });
            /*
            .catch((error: ResponseError) => {
                XXX.publish(ModalSubscriberTopic, { modalType: ApiResponseErrorModal, responseError: error });
            });
            */
        }

        hideImagePreview();
    }

    function onImagePreviewCancel() {
        hideImagePreview();
    }

    function onImageDeleteClick() {
        showPromptMessage(ModalMessageType.PromptYesNo, "Image Deletion", "Are you sure you want to delete this image?", DELETE_IMAGE_WARNING);


        /*
        let result = confirm("Are you sure you want to delete this image?", "Confirm Delete");

        result.then((dialogResult) => {
            if (dialogResult && currentImage && currentImage.imageId)
                deleteImage(currentImage.imageId)
                    .then(() => {
                        getImages();
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Deleting Image");
                    });
        });
        */

    }


    function onDeleteImage() {
        if (currentImage && currentImage.imageId)
            deleteImage(currentImage.imageId)
                .then(() => {
                    hideImagePreview();

                    getImages();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Image");
                });
    }

    async function onImageDownload() {
        if (currentImage && currentImage.imageId) {
            //let url = `media/image/${currentImage.imageId}`;

            await CrudFunctions.getDataBlob(`media/image/${currentImage.imageId}`)
                .then((blob: any) => {
                    let a = document.createElement("a") as HTMLAnchorElement;

                    document.body.appendChild(a);
                    a.style.display = "none";

                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    //todo:
                    a.download = currentImage.name ? currentImage.name : "image"; // `COA-${selectedBatch.batchName}.pdf`;
                    a.click();
                    window.URL.revokeObjectURL(url);

                    //to open PDF in browser:
                    // let file = window.URL.createObjectURL(blob);
                    // window.open(file, "_blank");
                });

            /*
        fetch(url)
            .then(response => {
                if (response.ok) {
                    return response.blob();
                } else {
                    //XXX.publish(ModalSubscriberTopic, { modalType: ApiResponseErrorModal, responseError: response });
                    //.catch ((res) => {
                        showMessage("error", ModalMessageType.Error, "Error Deleting Image");
                    //});
                }
            })
            .then((blob: any) => {
                let a = document.createElement("a") as HTMLAnchorElement;

                document.body.appendChild(a);
                a.style.display = "none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = currentImage.name ? currentImage.name : "image";
                a.click();
                window.URL.revokeObjectURL(url);
            });
            */
        }
    }

    function selectedImageChanged(e: any) {

        console.log("selectedImageChanged");
        console.log(e);
        console.log(e.currentTarget);

        if (e.currentTarget && e.currentTarget.id && images) {
            let imageId = e.currentTarget.id;

            //if (e.target && e.target.id && this.props.images) {
            //const imageId = e.target.id;
            const filteredImages = images.filter(i => i.imageId === imageId);

            if (filteredImages && filteredImages.length > 0) {
                const image = filteredImages[0] as AttachedImage;

                //this.setState({ currentImage: image, imageName: image.name, imageDescription: image.description });

                setCurrentImage(image);
                //setImageName(image.name);
                //setImageDescription(image.description);

                showImagePreview();
            }
        }
    }

    function changeCaptureType(e: any) {
        setCaptureTypeId(e.value);
        setCurrentImage(null);
    }

    function changeImageType(e: any) {
        console.log("prev selcted image type...");
        console.log(selectedCofAImageType);

        console.log("changeImageType");
        console.log(e);

        /*
        this.setState({
            selectedCofAImageType: e.value as ImageType
        });
        */

        //const imageType = imageTypes.find(t => t.id === e.value);

        setSelectedCofAImageType(e.value);
    }

    function onFileDragOver(e: any) {
        e.stopPropagation();
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
    }

    function onFileDrop(e: any) {
        e.stopPropagation();
        e.preventDefault();

        console.log("onFileDrop")
        console.log("selectedCofAImageType:");
        console.log(selectedCofAImageType);


        if (e.dataTransfer && e.dataTransfer.files) {
            let files = e.dataTransfer.files;

            if (files && files.length > 0) {
                let file = files[0];

                let image: AttachedImage = {
                    name: file.name,
                    imageType: selectedCofAImageType,
                    mimeTypeString: file.type
                };

                var reader = new FileReader();

                reader.onload = (event: any) => readFile(image, event)
                    .then((img) => {

                        //this.setState({ currentImage: img, imageName: img.name, imageDescription: '' });

                        setCurrentImage(img);
                        //setImageName(img.name);
                        //setImageDescription('');


                        showImagePreview();
                    });

                reader.readAsBinaryString(file);
            }
        }
    }

    async function onFileLoaderChange(e: any) {

        console.log("onFileLoaderChange");
        console.log(e);


        let files = e.target.files;

        if (files && files.length > 0) {
            let file = files[0];

            let image: AttachedImage = {
                name: file.name,
                mimeTypeString: file.type,
                imageType: selectedCofAImageType
            };

            var reader = new FileReader();

            reader.onload = (event: any) => readFile(image, event)
                .then((img) => {
                    if (img.base64Blob) {
                        setCurrentImage(img);

                        showImagePreview();
                    }
                });

            reader.readAsBinaryString(file);
        }
    }

    async function readFile(image: AttachedImage, event: any): Promise<any> {

        console.log("readFile");
        console.log(image);

        if (event && event.target && event.target.result) {
            let binaryString = event.target.result;
            let imageData = btoa(binaryString);

            image.base64Blob = imageData;
            image.fullBinaryString = event.target.result;

            return image;
        }
    }
    /*
    function onPaste(e: any) {
        let items = (e.event.clipboardData || e.event.originalEvent.clipboardData).items;

        for (let index in items) {
            var item = items[index];

            if (item.kind === 'file') {
                var blob = item.getAsFile();

                var reader = new FileReader();

                let image: AttachedImage = {
                    name: "image",
                    mimeTypeString: item.type
                };

                reader.onload = (event: any) => pasteFile(image, event)
                    .then((img) => {
                        //this.setState({ currentImage: img, imageName: img.name, imageDescription: '' });

                        setCurrentImage(img);
                        //setImageName(img.name);
                        //setImageDescription('');

                        showImagePreview();
                    });

                reader.readAsDataURL(blob);
            }
        }
    }
    
    async function pasteFile(image: AttachedImage, event: any): Promise<any> {
        if (event && event.target) {
            let binaryString = event.target.result;
            let imageData = btoa(binaryString);

            image.base64Blob = event.target.result;
            image.fullBinaryString = imageData;
        }

        return image;
    }
    */


    function onImageInfoButtonClick(e: any) {
        if (currentImage) {
            let image = currentImage;
            let itemBasicInitInformation: ItemBasicInformation = {
                rowPointer: image.imageId,
                createTimestamp: image.createTimestamp,
                lastModifiedTimestamp: image.modifyTimestamp,
                createUser: image.createUser,
                modifyUser: image.modifyUser
            };

            setItemBasicInitInformation(itemBasicInitInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    async function getImages() {
        await CrudFunctions.getData(`media/imagesbyparentid/${props.parentId}`)
            .then(data => {
                setImages(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Images");
            });
    }

    async function getImageTypes() {
        //if a single image type is passed into props then do not get a list of image types
        if (props.imageType) {

            let singleImageTypeList: LookupItem[] = [];
            singleImageTypeList.push({ id: props.imageType, name: "Weight Ticket" });

            setImageTypes(singleImageTypeList);
        }
        else {
            await CrudFunctions.getData(`common/imagetypesbytechnologyid/${props.technology}`)
                .then(data => {
                    setImageTypes(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Image Types");
                });
        }
    }

    async function insertImage(image: AttachedImage) {
        return await CrudFunctions.postData("media/image", image);
    }

    async function updateImage(image: AttachedImage) {
        return await CrudFunctions.putData("media/image", image);
    }


    async function deleteImage(imageId: string) {
        return await CrudFunctions.deleteData(`media/image/${imageId}`);
    }

    async function benchSheetDataImageSaved(image: AttachedImage) {
        image.parentId = props.parentId

        if (image.imageId) // if present, indicates an update for an already saved image
        {
            await updateImage(image)
                .then((res) => {
                    getImages();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Image");
                });

            return;
        }

        await insertImage(image)
            .then((res) => {
                getImages();
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Inserting Image");
            });
    }

    async function benchSheetDataCofAImageDeleted(imageId: string) {
        if (imageId) {
            await deleteImage(imageId)
                .then(() => {
                    getImages();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Image");
                });
        }
    }

    async function getAllData() {
        await Promise.all([
            await getImages(),
            await getImageTypes()
        ]);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showPromptMessage(mode: ModalMessageType, title: string, message: string, code: number) {
        let mm: ModalMetadata = {
            error: null,
            mode: mode,
            title: title,
            message: message,
            code: code
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function onGlobalDialogReply(reply: MessageBoxReply) {
        console.log("onGlobalDialogReply");
        console.log(reply);

        if (reply.code === DELETE_IMAGE_WARNING) {

            clearGlobalDialog();

            if (reply.reply !== MessageBoxReplyType.Yes)
                return;

            onDeleteImage();
        }
    }

    function onGlobalDialogClose() {
        clearGlobalDialog();
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}
